import { AccountBadgeUserViewTable } from '../../../../ui/features/badge-account/components/AccountBadgeUserViewTable/AccountBadgeUserViewTable';
import { AccountBadgeSlideout } from '../../../../ui/features/badge-management/components/AccountBadgeSlideout/AccountBadgeSlideout';
import { Box } from '@mui/material';
import React from 'react';
const BadgesAccountSection = (props) => {
    var _a;
    if (!props.accountId) {
        return null;
    }
    const AccountBadgeSlideoutImpl = (_a = props.buildAccountBadgeSlideoutComponent) === null || _a === void 0 ? void 0 : _a.call(props, AccountBadgeSlideout);
    return (React.createElement(Box, null,
        React.createElement(AccountBadgeUserViewTable, { accountId: props.accountId, AccountBadgeSlideoutComponent: AccountBadgeSlideoutImpl })));
};
/**
 * For usage with {@link ContactManagementConfigProvider} e.g.
 *
 * ```
 * <ContactManagementConfigProvider
 *     accountConfig={{
 *         component: {
 *             badgesSection: buildBadgeAccountSectionComponent(buildAccountBadgeSlideoutComponent),
 *         },
 *     }}
 * >
 * ```
 *
 * @param buildAccountBadgeSlideoutComponent build custom slideout component
 */
export function buildBadgeAccountSectionComponent(buildAccountBadgeSlideoutComponent) {
    return (props) => React.createElement(BadgesAccountSection, Object.assign({}, props, { buildAccountBadgeSlideoutComponent: buildAccountBadgeSlideoutComponent }));
}
